<template>
  <span class="textarea-plus">
    <textarea
      :maxlength="maxlength"
      :value="value"
      v-on:keyup="handleKeyStroke"
      v-on:paste="handleKeyStroke"
      class="form-control"
      :placeholder="placeholder"
    ></textarea>
  </span>
</template>

<script>
export default {
  name: 'textarea-plus',
  props: {
    placeholder: String, 
    value: String, 
    maxlength: {
      type: [Number, Boolean],
      required: false,
      default: false
    }
    },
  methods: {
    handleKeyStroke: function handleKeyStroke (event) {
      this.textareaAdjust(event)
      this.$emit('onChange', event.target.value)
    },
    textareaAdjust: function textAreaAdjust (event) {
      var el = event.target
      el.style.height = '1px'
      el.style.height = (25 + el.scrollHeight) + 'px'
    }
  }
}
</script>

<style scoped>
    textarea { 
        resize: vertical; 
        overflow: hidden;
    }
</style>
